export function getVideoType(videoSrc) {
    let videoType = ''

    if (videoSrc.includes('.webm')) {
        videoType = 'video/webm'
    } else if (videoSrc.includes('.mov')) {
        videoType = 'video/mov'
    } else if (videoSrc.includes('.mp4')) {
        videoType = 'video/mp4'
    }

    return videoType
}
